module.exports = __webpack_public_path__ + "static/media/onedrive.ecfd10a6.svg";